import { MembershipsSpotifyIntegrationsApiClient } from '@fourthwall/services/dist/MembershipsSpotifyIntegrationsApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const usePodcastsQuery = createQueryHook(
  MembershipsSpotifyIntegrationsApiClient.getPodcasts,
  { queryKey: ['podcasts'] },
)
